export const storecfg = {
    accountState: {},
    networkState: {},
    appKitState: {},
    themeState: { themeMode: 'light', themeVariables: {} },
    events: [],
    walletInfo: {},
    eip155Provider: null
  }
  
  export const updateStore = (key, value) => {
    storecfg[key] = value
  }